import { render, staticRenderFns } from "./DocumentGuidePages.vue?vue&type=template&id=44359912&scoped=true&"
import script from "./DocumentGuidePages.vue?vue&type=script&lang=js&"
export * from "./DocumentGuidePages.vue?vue&type=script&lang=js&"
import style0 from "./DocumentGuidePages.vue?vue&type=style&index=0&id=44359912&scoped=true&lang=css&"
import style1 from "./DocumentGuidePages.vue?vue&type=style&index=1&id=44359912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44359912",
  null
  
)

export default component.exports